import { SortBy, SortingDirection } from 'spw-components/collab/types';
import { EntityList } from 'spw-redux/types';
import { ProjectSlimForList } from '../projects/types';
import { IUser } from '../user/types';

export interface Team {
  id: number;
  name: string;
  image?: string; // for mutations only
  hasLogo?: boolean;
  thumbnailS3Path?: string;
  requiresRequestToJoin: boolean;
  numberOfMembers?: number;
  numberOfProjects?: number;
  teamAdmins?: TeamMember[];
  users?: IUser[];
  currentUserRole?: UserRoleInTeam;
}

export type TeamSortOptions = {
  name?: SortingDirection;
};

export type TeamsSortParams = {
  sort?: TeamSortOptions;
  page?: number;
  perPage?: number;
};

export type GetUsersInTeamParams = {
  teamId: number;
  sort?: TeamUsersSortOptions;
  page?: number;
  perPage?: number;
};

// UserRoleInTeam describes the current users role in the given team
export enum UserRoleInTeam {
  viewer = 'VIEWER',
  teamMember = 'TEAM_MEMBER',
  teamAdmin = 'TEAM_ADMIN',
  orgAdmin = 'ORG_ADMIN',
}

export enum TeamAction {
  editTeam = 'Edit Team',
  manageTeamAdmin = 'Manage Team Admins',
  leaveTeam = 'Leave Team',
  joinTeam = 'Join Team',
  requestToJoin = 'Ask to Join',
  deleteTeam = 'Delete Team',
  addTeamMembers = 'Add Team Members',
}

export type TeamSlimForList = Omit<Team, ''>;

export enum TeamActionForUser {
  reassign = 'REASSIGN',
  remove = 'REMOVE',
  askToJoin = 'ASK TO JOIN',
  leave = 'LEAVE',
  join = 'JOIN',
}

export type TeamListItemVM = Omit<Team, ''> & {
  action?: TeamActionForUser;
};

export type TeamDetailVM = Omit<Team, 'users' | 'teamAdmins'> & {
  teamAdmins: TeamMemberListVM[];
  users: TeamMemberListVM[];
};

export type TeamSlim = Pick<
  Team,
  'id' | 'name' | 'hasLogo' | 'thumbnailS3Path'
>;

export enum TeamMemberRole {
  admin = 'admin',
  user = 'user',
}

export type TeamMember = Pick<
  IUser,
  | 'id'
  | 'name'
  | 'numberOfProjects'
  | 'numberOfTeams'
  | 'officeLocation'
  | 'professionalRole'
  | 'hasAvatar'
  | 'thumbnailS3Path'
  | 'isActive'
>;

export type TeamMemberListVM = Omit<TeamMember, ''> & {
  role: TeamMemberRole;
  action?: 'REASSIGN' | 'REMOVE';
};

export type TeamsSortBy = SortBy<'name'>;

export type TeamUsersSortOptions = {
  default?: SortingDirection;
  id?: SortingDirection;
  name?: SortingDirection;
};

export type TeamMembersSortBy = SortBy<keyof TeamUsersSortOptions>;

export enum TeamFormPermissionSettings {
  join = 'join',
  requiresRequestToJoin = 'requiresRequestToJoin',
}

export type TeamForm = {
  name: string;
  teamAdmin1: TeamMember;
  teamAdmin2: TeamMember;
  permissionSettings: TeamFormPermissionSettings;
};

export type UpdateTeamFields = {
  teamId: number;
  image?: string;
  name?: string;
  requiresRequestToJoin?: boolean;
  teamAdmins?: number[];
};

export type ITeamsState = {
  list: EntityList<TeamListItemVM>;
  team: TeamDetailVM;
  loading: boolean;
  teamsForProjectList: EntityList<TeamListItemVM>;
  projectsForTeamList: EntityList<ProjectSlimForList>;
  teamsForPopoverList: EntityList<TeamSlim>;
  teamMembersForTeamList: EntityList<TeamMemberListVM>;
};
